import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { length } from 'file-loader';
import React, { useState, useEffect } from 'react';
import LoadScript from "react-load-script";
import { generatePath } from 'react-router-dom';
import bluePin from '../../images/blue-pin.png';
import redStar from '../../images/smooth-red-star.png';
import { orderBy } from 'lodash';
var map, popup, dataSource, iconLayer, centerMarker, searchURL;
var iconPinUrl = bluePin;
var iconLocationUrl = redStar;
var userLocation;
var userLocationData;
var locationData = [];
var features = [];
var mapCenterMarker;
var tab = 0;
var tripPlannerCache = {};
var azureKey = 'SQwN2uUaVaqXvNcFLrblgyzfl0oqEVmkQ_WrPLfs8wc';
/*let locationData = [{ "aboutUsDescription": "", "address1": "30 Research Dr.", "address2": "I-95 & Woodmont Rd.", "alternateName": "Milford", "avgWaitTime": "0 minutes", "beerWine": "", "careers": "", "catering": true, "cateringDelivery": true, "cateringDeliveryAvailable": true, "cateringDeliveryLaunchDate": "0001-01-01T00:00:00", "cateringMenu": false, "city": "Milford", "companyUid": "8ca6a7d3-8083-11e4-9f8d-22000b510bd7", "country": "US", "curbside": true, "dineIn": false, "dispatchIndividual": true, "englishBreakfast": "http://www.crackerbarrel.com/menupdfs/STORE_318_BK_MENU_EN.pdf", "englishLunchDinner": "", "facebookPage": "", "familyValueMeals": false, "featuredMenu": "", "fridayClose": "10:00 PM", "fridayOpen": "8:00 AM", "frontPorchDining": false, "ghostKitchen": false, "holidayHns": false, "individualMeals": true, "integratedCateringDelivery": false, "localPageImage1": "", "localPageImage2": "", "localPageImage3": "", "maxLiveDate": "0001-01-01T00:00:00", "mondayClose": "9:00 PM", "mondayOpen": "8:00 AM", "name": "Cracker Barrel", "nowOpen": "", "oloCateringUniqueName": "milford-ct-catering", "oloStore": true, "oloUniqueName": "milford-ct", "onlineOrdering": false, "openingSoon": false, "park": true, "payInApp": false, "phone": "203-877-7595", "pickUp": true, "posSystem": "", "saturdayClose": "10:00 PM", "saturdayOpen": "8:00 AM", "spanishBreakfast": "http://www.crackerbarrel.com/menupdfs/STORE_318_BK_MENU_ES.pdf", "spanishLunchDinner": "http://www.crackerbarrel.com/menupdfs/STORE_318_LD_MENU_ES.pdf", "specialHours": "", "specialNotes": "Our kitchen is open for Curbside, Pickup & Delivery, but our dining room is closed temporarily due to COVID-19. Our retail store is open. ​", "state": "CT", "storeId": "0e27ef8a-5561-481a-90f0-9d46af07fa50", "storeNumber": "318", "sundayClose": "9:00 PM", "sundayOpen": "8:00 AM", "temporarilyClosed": false, "thursdayClose": "9:00 PM", "thursdayOpen": "8:00 AM", "tuesdayClose": "9:00 PM", "tuesdayOpen": "8:00 AM", "vendorId": "62575", "vendorIdCatering": "63340", "waitlist": false, "webAheadStatus": "Available", "wednesdayClose": "9:00 PM", "wednesdayOpen": "8:00 AM", "yelpReOpenDate": "0001-01-01T00:00:00", "zip": "06460-8523", "latitude": "41.2386057", "longitude": "-73.0199779" },
{ "aboutUsDescription": "", "address1": "30 Research Dr.", "address2": "I-95 & Woodmont Rd.", "alternateName": "Milford", "avgWaitTime": "0 minutes", "beerWine": "", "careers": "", "catering": true, "cateringDelivery": true, "cateringDeliveryAvailable": true, "cateringDeliveryLaunchDate": "0001-01-01T00:00:00", "cateringMenu": false, "city": "Milford", "companyUid": "9ca6a7d3-8083-11e4-9f8d-22000b510bd7", "country": "US", "curbside": true, "dineIn": false, "dispatchIndividual": true, "englishBreakfast": "http://www.crackerbarrel.com/menupdfs/STORE_318_BK_MENU_EN.pdf", "englishLunchDinner": "", "facebookPage": "", "familyValueMeals": false, "featuredMenu": "", "fridayClose": "10:00 PM", "fridayOpen": "8:00 AM", "frontPorchDining": false, "ghostKitchen": false, "holidayHns": false, "individualMeals": true, "integratedCateringDelivery": false, "localPageImage1": "", "localPageImage2": "", "localPageImage3": "", "maxLiveDate": "0001-01-01T00:00:00", "mondayClose": "9:00 PM", "mondayOpen": "8:00 AM", "name": "Cracker Barrel", "nowOpen": "", "oloCateringUniqueName": "milford-ct-catering", "oloStore": true, "oloUniqueName": "milford-ct", "onlineOrdering": false, "openingSoon": false, "park": true, "payInApp": false, "phone": "203-877-7595", "pickUp": true, "posSystem": "", "saturdayClose": "10:00 PM", "saturdayOpen": "8:00 AM", "spanishBreakfast": "http://www.crackerbarrel.com/menupdfs/STORE_318_BK_MENU_ES.pdf", "spanishLunchDinner": "http://www.crackerbarrel.com/menupdfs/STORE_318_LD_MENU_ES.pdf", "specialHours": "", "specialNotes": "Our kitchen is open for Curbside, Pickup & Delivery, but our dining room is closed temporarily due to COVID-19. Our retail store is open. ​", "state": "CT", "storeId": "0e27ef8a-5561-481a-90f0-9d46af07fa50", "storeNumber": "318", "sundayClose": "9:00 PM", "sundayOpen": "8:00 AM", "temporarilyClosed": false, "thursdayClose": "9:00 PM", "thursdayOpen": "8:00 AM", "tuesdayClose": "9:00 PM", "tuesdayOpen": "8:00 AM", "vendorId": "62575", "vendorIdCatering": "63340", "waitlist": false, "webAheadStatus": "Available", "wednesdayClose": "9:00 PM", "wednesdayOpen": "8:00 AM", "yelpReOpenDate": "0001-01-01T00:00:00", "zip": "06460-8523", "latitude": "40.2386057", "longitude": "-70.0199779" }];
*/

/*let locationData2 = [{ "aboutUsDescription": "", "address1": "30 Research Dr.", "address2": "I-95 & Woodmont Rd.", "alternateName": "Milford", "avgWaitTime": "0 minutes", "beerWine": "", "careers": "", "catering": true, "cateringDelivery": true, "cateringDeliveryAvailable": true, "cateringDeliveryLaunchDate": "0001-01-01T00:00:00", "cateringMenu": false, "city": "Milford", "companyUid": "8ca6a7d3-8083-11e4-9f8d-22000b510bd7", "country": "US", "curbside": true, "dineIn": false, "dispatchIndividual": true, "englishBreakfast": "http://www.crackerbarrel.com/menupdfs/STORE_318_BK_MENU_EN.pdf", "englishLunchDinner": "", "facebookPage": "", "familyValueMeals": false, "featuredMenu": "", "fridayClose": "10:00 PM", "fridayOpen": "8:00 AM", "frontPorchDining": false, "ghostKitchen": false, "holidayHns": false, "individualMeals": true, "integratedCateringDelivery": false, "localPageImage1": "", "localPageImage2": "", "localPageImage3": "", "maxLiveDate": "0001-01-01T00:00:00", "mondayClose": "9:00 PM", "mondayOpen": "8:00 AM", "name": "Cracker Barrel", "nowOpen": "", "oloCateringUniqueName": "milford-ct-catering", "oloStore": true, "oloUniqueName": "milford-ct", "onlineOrdering": false, "openingSoon": false, "park": true, "payInApp": false, "phone": "203-877-7595", "pickUp": true, "posSystem": "", "saturdayClose": "10:00 PM", "saturdayOpen": "8:00 AM", "spanishBreakfast": "http://www.crackerbarrel.com/menupdfs/STORE_318_BK_MENU_ES.pdf", "spanishLunchDinner": "http://www.crackerbarrel.com/menupdfs/STORE_318_LD_MENU_ES.pdf", "specialHours": "", "specialNotes": "Our kitchen is open for Curbside, Pickup & Delivery, but our dining room is closed temporarily due to COVID-19. Our retail store is open. ​", "state": "CT", "storeId": "0e27ef8a-5561-481a-90f0-9d46af07fa50", "storeNumber": "318", "sundayClose": "9:00 PM", "sundayOpen": "8:00 AM", "temporarilyClosed": false, "thursdayClose": "9:00 PM", "thursdayOpen": "8:00 AM", "tuesdayClose": "9:00 PM", "tuesdayOpen": "8:00 AM", "vendorId": "62575", "vendorIdCatering": "63340", "waitlist": false, "webAheadStatus": "Available", "wednesdayClose": "9:00 PM", "wednesdayOpen": "8:00 AM", "yelpReOpenDate": "0001-01-01T00:00:00", "zip": "06460-8523", "latitude": "42.2386057", "longitude": "-73.0199779" },
{ "aboutUsDescription": "", "address1": "30 Research Dr.", "address2": "I-95 & Woodmont Rd.", "alternateName": "Milford", "avgWaitTime": "0 minutes", "beerWine": "", "careers": "", "catering": true, "cateringDelivery": true, "cateringDeliveryAvailable": true, "cateringDeliveryLaunchDate": "0001-01-01T00:00:00", "cateringMenu": false, "city": "Milford", "companyUid": "9ca6a7d3-8083-11e4-9f8d-22000b510bd7", "country": "US", "curbside": true, "dineIn": false, "dispatchIndividual": true, "englishBreakfast": "http://www.crackerbarrel.com/menupdfs/STORE_318_BK_MENU_EN.pdf", "englishLunchDinner": "", "facebookPage": "", "familyValueMeals": false, "featuredMenu": "", "fridayClose": "10:00 PM", "fridayOpen": "8:00 AM", "frontPorchDining": false, "ghostKitchen": false, "holidayHns": false, "individualMeals": true, "integratedCateringDelivery": false, "localPageImage1": "", "localPageImage2": "", "localPageImage3": "", "maxLiveDate": "0001-01-01T00:00:00", "mondayClose": "9:00 PM", "mondayOpen": "8:00 AM", "name": "Cracker Barrel", "nowOpen": "", "oloCateringUniqueName": "milford-ct-catering", "oloStore": true, "oloUniqueName": "milford-ct", "onlineOrdering": false, "openingSoon": false, "park": true, "payInApp": false, "phone": "203-877-7595", "pickUp": true, "posSystem": "", "saturdayClose": "10:00 PM", "saturdayOpen": "8:00 AM", "spanishBreakfast": "http://www.crackerbarrel.com/menupdfs/STORE_318_BK_MENU_ES.pdf", "spanishLunchDinner": "http://www.crackerbarrel.com/menupdfs/STORE_318_LD_MENU_ES.pdf", "specialHours": "", "specialNotes": "Our kitchen is open for Curbside, Pickup & Delivery, but our dining room is closed temporarily due to COVID-19. Our retail store is open. ​", "state": "CT", "storeId": "0e27ef8a-5561-481a-90f0-9d46af07fa50", "storeNumber": "318", "sundayClose": "9:00 PM", "sundayOpen": "8:00 AM", "temporarilyClosed": false, "thursdayClose": "9:00 PM", "thursdayOpen": "8:00 AM", "tuesdayClose": "9:00 PM", "tuesdayOpen": "8:00 AM", "vendorId": "62575", "vendorIdCatering": "63340", "waitlist": false, "webAheadStatus": "Available", "wednesdayClose": "9:00 PM", "wednesdayOpen": "8:00 AM", "yelpReOpenDate": "0001-01-01T00:00:00", "zip": "06460-8523", "latitude": "43.2386057", "longitude": "-70.0199779" }]
*/

var LocationAzureMap = function LocationAzureMap(props) {
  var _props$src = props.src,
      src = _props$src === void 0 ? "https://hosted.where2getit.com/crackerbarrel/storelocator.html" : _props$src,
      _props$results = props.results,
      results = _props$results === void 0 ? [] : _props$results,
      zipcode = props.zipcode,
      height = props.height,
      currentSelectedZip = props.currentSelectedZip,
      tripPlannerAddress = props.tripPlannerAddress,
      activeTab = props.activeTab,
      _props$setTripPlanner = props.setTripPlannerLoc,
      setTripPlannerLoc = _props$setTripPlanner === void 0 ? function () {
    return "";
  } : _props$setTripPlanner,
      tripPlannerLoc = props.tripPlannerLoc,
      _props$savePathInfo = props.savePathInfo,
      savePathInfo = _props$savePathInfo === void 0 ? function () {
    return "";
  } : _props$savePathInfo;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      mapControlScript = _useState2[0],
      setControl = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      mapServiceScript = _useState4[0],
      setService = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      mapLoaded = _useState6[0],
      setLoaded = _useState6[1];

  useEffect(function () {
    if (activeTab == 0 && mapServiceScript && mapControlScript) {
      if (JSON.stringify(results) != JSON.stringify(locationData)) {
        var _dataSource, _map, _map$markers;

        getUserLocation();
        (_dataSource = dataSource) === null || _dataSource === void 0 ? void 0 : _dataSource.clear();
        (_map = map) === null || _map === void 0 ? void 0 : (_map$markers = _map.markers) === null || _map$markers === void 0 ? void 0 : _map$markers.clear(mapCenterMarker);
        features = [];
        fetch('https://atlas.microsoft.com/search/address/json?&subscription-key=' + azureKey + '&api-version=1.0&countrySet=US&language=en-US&query=' + userLocation).then(function (res) {
          return res.json();
        }).then(function (result) {
          var _userLocationData, _userLocationData$res, _userLocationData2, _userLocationData2$re;

          userLocationData = result;
          setupData();
          map.setCamera({
            center: [(_userLocationData = userLocationData) === null || _userLocationData === void 0 ? void 0 : (_userLocationData$res = _userLocationData.results[0]) === null || _userLocationData$res === void 0 ? void 0 : _userLocationData$res.position.lon, (_userLocationData2 = userLocationData) === null || _userLocationData2 === void 0 ? void 0 : (_userLocationData2$re = _userLocationData2.results[0]) === null || _userLocationData2$re === void 0 ? void 0 : _userLocationData2$re.position.lat],
            zoom: 8
          });
        }, function (error) {//console.log(error);
        });
      } else {
        initMap();
      }
    } else if (activeTab == 1 && mapServiceScript && mapControlScript) {
      var _dataSource2, _map$markers2;

      //Trip Planner
      (_dataSource2 = dataSource) === null || _dataSource2 === void 0 ? void 0 : _dataSource2.clear();
      (_map$markers2 = map.markers) === null || _map$markers2 === void 0 ? void 0 : _map$markers2.clear(); //map.clear();

      features = [];
      initMap();
      tripPlannerCache = {};
    } else {
      initMap();
    }
  }, [mapServiceScript, mapControlScript, mapLoaded, results, tripPlannerAddress, activeTab]);

  var getUserLocation = function getUserLocation() {
    var _locationData$;

    locationData = results; // console.log(results)

    userLocation = zipcode || ((_locationData$ = locationData[0]) === null || _locationData$ === void 0 ? void 0 : _locationData$.Zip) || currentSelectedZip || "37087";
  };

  var handleMapControlScript = function handleMapControlScript() {
    setControl(true);
  };

  var handleMapServiceScript = function handleMapServiceScript() {
    setService(true);
  };

  var initMap = function initMap() {
    if (activeTab == 0) {
      //Store Finder
      getUserLocation();

      if (mapServiceScript && mapControlScript && !mapLoaded) {
        setLoaded(true);
        fetch('https://atlas.microsoft.com/search/address/json?&subscription-key=' + azureKey + '&api-version=1.0&countrySet=US&language=en-US&query=' + userLocation).then(function (res) {
          return res.json();
        }).then(function (result) {
          userLocationData = result;
          renderMap();
        }, function (error) {//console.log(error);
        });
      }
    } else if (activeTab == 1) {
      var _dataSource3, _map2, _map2$markers;

      //Trip Planner
      (_dataSource3 = dataSource) === null || _dataSource3 === void 0 ? void 0 : _dataSource3.clear();
      (_map2 = map) === null || _map2 === void 0 ? void 0 : (_map2$markers = _map2.markers) === null || _map2$markers === void 0 ? void 0 : _map2$markers.clear(mapCenterMarker);
      features = [];
      getPath();
    }
  };

  var getPath = function getPath() {
    var _props$tripPlannerAdd, _tripPlannerCache, _props$tripPlannerAdd2, _tripPlannerCache2;

    //console.log(props);
    var address1 = ((_props$tripPlannerAdd = props.tripPlannerAddress) === null || _props$tripPlannerAdd === void 0 ? void 0 : _props$tripPlannerAdd.address1) || ((_tripPlannerCache = tripPlannerCache) === null || _tripPlannerCache === void 0 ? void 0 : _tripPlannerCache.address1);
    var address2 = ((_props$tripPlannerAdd2 = props.tripPlannerAddress) === null || _props$tripPlannerAdd2 === void 0 ? void 0 : _props$tripPlannerAdd2.address2) || ((_tripPlannerCache2 = tripPlannerCache) === null || _tripPlannerCache2 === void 0 ? void 0 : _tripPlannerCache2.address2);

    if (!address1 || !address2) {
      return;
    }

    tripPlannerCache.address1 = props.tripPlannerAddress.address1;
    tripPlannerCache.address2 = props.tripPlannerAddress.address2;
    var address1Coords = [];
    var address2Coords = [];
    fetch('https://atlas.microsoft.com/search/address/json?&subscription-key=' + azureKey + '&api-version=1.0&countrySet=US&language=en-US&query=' + address1).then(function (res) {
      return res.json();
    }).then(function (result) {
      address1Coords.push(result.results[0].position.lat);
      address1Coords.push(result.results[0].position.lon);
      ;
      fetch('https://atlas.microsoft.com/search/address/json?&subscription-key=' + azureKey + '&api-version=1.0&countrySet=US&language=en-US&query=' + address2).then(function (res) {
        return res.json();
      }).then(function (result) {
        address2Coords.push(result.results[0].position.lat);
        address2Coords.push(result.results[0].position.lon);
        getRoute(address1Coords, address2Coords);
      }, function (error) {//console.log(error);
      });
    }, function (error) {//console.log(error);
    });
  };

  var getRoute = function getRoute(start, end) {
    fetch('https://atlas.microsoft.com/route/directions/json?&subscription-key=' + azureKey + '&api-version=1.0&query=' + start + ':' + end).then(function (res) {
      return res.json();
    }).then(function (result) {
      //console.log(result);
      var coordinates = [];
      savePathInfo(result);

      for (var i = 0; i < result.routes[0].legs[0].points.length; i++) {
        var point = [];
        point.push(result.routes[0].legs[0].points[i].longitude);
        point.push(result.routes[0].legs[0].points[i].latitude);
        coordinates.push(point);
      }
      /*add route line to the dataSource*/


      dataSource.add(new atlas.data.Feature(new atlas.data.LineString(coordinates)));
      getPOI(coordinates, start, end);
    }, function (error) {//console.log(error);
    });
  };

  var getPOI = function getPOI(points, start, end) {
    var request = {
      "route": {
        "type": "LineString",
        "coordinates": points
      }
    };
    fetch('https://atlas.microsoft.com/search/alongRoute/json?&subscription-key=' + azureKey + '&api-version=1.0&query=Cracker Barrel&maxDetourTime=900', {
      method: "POST",
      body: JSON.stringify(request) //headers: { "Content-type": "application/json; charset=UTF-8" }

    }).then(function (response) {
      return response.json();
    }).then(function (json) {
      return renderTripPlannerMap(json.results, start, end);
    }).catch(function (err) {
      return console.log(err);
    });
  };

  var renderTripPlannerMap = function renderTripPlannerMap(parentdata, start, end) {
    var startCoords = start.reverse();
    var endCoords = end.reverse();
    var locResults = [];
    var locCoords = [];
    var locDetails = [];
    var data = orderBy(parentdata, 'dist', 'desc').filter(function (el) {
      var _el$address, _el$poi;

      return (el === null || el === void 0 ? void 0 : (_el$address = el.address) === null || _el$address === void 0 ? void 0 : _el$address.streetNumber) && (el === null || el === void 0 ? void 0 : (_el$poi = el.poi) === null || _el$poi === void 0 ? void 0 : _el$poi.url);
    }); // Use Lodash to sort array by 'dist'

    for (var i = 0; i < data.length; i++) {
      var name = data[i].poi.name; //console.log(i);

      if (name.includes('Cracker Barrel')) {
        var _poiData;

        var poiData = (_poiData = {
          POIStreetNumber: data[i].address.streetNumber,
          POIStreetName: data[i].address.streetName,
          //POIPhone: data[i].poi.phone,
          //Commented due to client request
          POIURL: data[i].poi.url,
          POIPosition: data[i].position,
          POIDistance: data[i].dist,
          POICity: data[i].address.municipality,
          POIState: data[i].address.countrySubdivision,
          POIZipcode: data[i].address.postalCode,
          POIDetail: data[i].poi.url,
          POICountry: data[i].address.countryCode
        }, _defineProperty(_poiData, "POIDistance", data[i].detourDistance), _defineProperty(_poiData, "FullPOI", data[i]), _poiData);

        if (!poiData.POIStreetNumber || !poiData.POIDetail) {} else {
          var _data$i;

          locResults.push(data[i]);
          locCoords.push(new atlas.data.Feature(new atlas.data.Point([parseFloat(data[i].position.lon), parseFloat(data[i].position.lat)]), {
            index: i,
            companyUid: (_data$i = data[i]) === null || _data$i === void 0 ? void 0 : _data$i.CompanyUid,
            POI: true
          }));
          locDetails.push(poiData);
        }
      }
    } // Magically Send locDetails to TripPlanner.js


    var mappedValues = locDetails.map(function (el) {
      var _ref;

      var POIStreetNumber = el.POIStreetNumber,
          POIStreetName = el.POIStreetName,
          POIPhone = el.POIPhone,
          POIDetail = el.POIDetail,
          POICity = el.POICity,
          POICountry = el.POICountry,
          POIDistance = el.POIDistance,
          POIState = el.POIState,
          POIZipcode = el.POIZipcode;

      if (!POIStreetNumber || !POIDetail) {
        return null;
      }

      var address = "".concat(POIStreetNumber, " ").concat(POIStreetName);
      return _ref = {
        address1: address,
        "address2": "",
        "alternate_name": undefined,
        phone: POIPhone,
        detailLink: POIDetail,
        "clientkey": undefined,
        "city": POICity,
        "country": POICountry,
        //detourDistance: POIDistance,
        "name": "Cracker Barrel"
      }, _defineProperty(_ref, "phone", POIPhone), _defineProperty(_ref, "state", POIState), _defineProperty(_ref, "storeaddress", {
        "value": address
      }), _defineProperty(_ref, "storename", {
        "value": "Cracker Barrel - Store"
      }), _defineProperty(_ref, "storephone", {
        "value": POIPhone
      }), _defineProperty(_ref, "postalcode", POIZipcode), _defineProperty(_ref, "zip", POIZipcode), _ref;
    }); // console.log(mappedValues.filter(Boolean), "MAPPED VALUES")

    setTripPlannerLoc(mappedValues.filter(Boolean)); // //Plot start/destitation points
    // var startPoint = new atlas.data.Point(startCoords);
    // var startPin = new atlas.data.Feature(startPoint);
    // var destinationPoint = new atlas.data.Point(endCoords);
    // var destinationPin = new atlas.data.Feature(destinationPoint);
    // // dataSource.add([startPin, destinationPin]);
    //Plot Line

    map.layers.add(new atlas.layer.LineLayer(dataSource, null, {
      strokeColor: '#4F758B',
      strokeWidth: 4,
      lineJoin: 'round',
      lineCap: 'round'
    }), 'labels'); //Plot POI

    dataSource.add(new atlas.data.FeatureCollection(locCoords));
    /* Fit map window to the bounding box defined by the start and destination points */

    var swLon = Math.min(start[0], end[0]);
    var swLat = Math.min(start[1], end[1]);
    var neLon = Math.max(start[0], end[0]);
    var neLat = Math.max(start[1], end[1]);
    map.setCamera({
      bounds: [swLon, swLat, neLon, neLat],
      padding: 55
    });
  };

  var renderMap = function renderMap() {
    var _userLocationData3, _userLocationData3$re, _userLocationData3$re2, _userLocationData4, _userLocationData4$re, _userLocationData4$re2;

    var lon = ((_userLocationData3 = userLocationData) === null || _userLocationData3 === void 0 ? void 0 : (_userLocationData3$re = _userLocationData3.results[0]) === null || _userLocationData3$re === void 0 ? void 0 : (_userLocationData3$re2 = _userLocationData3$re.position) === null || _userLocationData3$re2 === void 0 ? void 0 : _userLocationData3$re2.lon) || 36.208056;
    var lat = ((_userLocationData4 = userLocationData) === null || _userLocationData4 === void 0 ? void 0 : (_userLocationData4$re = _userLocationData4.results[0]) === null || _userLocationData4$re === void 0 ? void 0 : (_userLocationData4$re2 = _userLocationData4$re.position) === null || _userLocationData4$re2 === void 0 ? void 0 : _userLocationData4$re2.lat) || -86.326389;
    map = new atlas.Map('myMap', {
      center: [lon, lat],
      zoom: 8,
      language: 'en-US',
      view: 'Auto',
      style: "road",
      authOptions: {
        authType: 'subscriptionKey',
        subscriptionKey: azureKey
      }
    });
    map.events.add('ready', function () {
      map.controls.add(new atlas.control.ZoomControl(), {
        position: 'top-right'
      });
      setupData();
    });
  };

  var setupData = function setupData() {
    var _userLocationData5, _userLocationData5$re, _userLocationData5$re2, _userLocationData6, _userLocationData6$re, _userLocationData6$re2;

    //Create a data source and add it to the map.
    dataSource = new atlas.source.DataSource();
    map.sources.add(dataSource);
    var lon = ((_userLocationData5 = userLocationData) === null || _userLocationData5 === void 0 ? void 0 : (_userLocationData5$re = _userLocationData5.results[0]) === null || _userLocationData5$re === void 0 ? void 0 : (_userLocationData5$re2 = _userLocationData5$re.position) === null || _userLocationData5$re2 === void 0 ? void 0 : _userLocationData5$re2.lon) || 36.208056;
    var lat = ((_userLocationData6 = userLocationData) === null || _userLocationData6 === void 0 ? void 0 : (_userLocationData6$re = _userLocationData6.results[0]) === null || _userLocationData6$re === void 0 ? void 0 : (_userLocationData6$re2 = _userLocationData6$re.position) === null || _userLocationData6$re2 === void 0 ? void 0 : _userLocationData6$re2.lat) || -86.326389;
    mapCenterMarker = new atlas.HtmlMarker({
      //draggable: true,
      //Tip: add "pointer-events:none" as a style on the html content to disable the default drag behavior in MS Edge which will display an unwanted icon.
      htmlContent: "<img src=".concat(redStar, " style=\"pointer-events: none;\" />"),
      position: [lon, lat],
      pixelOffset: [5, -15]
    });
    var output = document.getElementById('output'); //Add a drag event to get the position of the marker. Markers support drag, dragstart and dragend events.

    /*map.events.add('drag', mapCenterMarker, function () {
      var pos = mapCenterMarker.getOptions().position;
       //Round longitude,latitude values to 5 decimal places.
      //output.innerText = Math.round(pos[0] * 100000) / 100000 + ', ' + Math.round(pos[1] * 100000) / 100000;
    });*/
    //Add the marker to the map.

    map.markers.add(mapCenterMarker);
    loadStoreData();
  };

  var loadStoreData = function loadStoreData() {
    features = [];
    /*fetch(storeLocationDataUrl)
      .then(response => response.json())
      .then(data => parseLocationData(data));*/
    //parseLocationData(data);
    //const parseLocationData = (data) => {
    //console.log(locationData);

    for (var i = 0; i < locationData.length; i++) {
      //console.log(locationData[i].companyUid);
      features.push(new atlas.data.Feature(new atlas.data.Point([parseFloat(locationData[i].Longitude), parseFloat(locationData[i].Latitude)]), {
        companyUid: locationData[i].CompanyUid,
        index: i
      }));
    } //console.log(features);


    dataSource.add(new atlas.data.FeatureCollection(features)); // Load a custom image icon into the map resources.

    map.imageSprite.add('myCustomIcon', iconPinUrl).then(function () {
      //Create a layer to render a coffee cup symbol above each bubble for an individual location.
      iconLayer = new atlas.layer.SymbolLayer(dataSource, null, {
        iconOptions: {
          //Pass in the ID of the custom icon that was loaded into the map resources.
          image: 'myCustomIcon',
          //Optionally, scale the size of the icon.
          font: ['SegoeUi-Bold'],
          //Anchor the center of the icon image to the coordinate.
          anchor: 'center',
          //Allow the icons to overlap.
          allowOverlap: true
        },
        // filter: ['!', ['has', 'point_count']] //Filter out clustered points from this layer.
        filter: ["==", ["geometry-type"], "Point"]
      });
      map.layers.add(iconLayer); // console.log(dataSource, "PREADD")
      //handle click event of CB Location Markers

      map.events.add('click', iconLayer, function (e) {
        //console.log(e);
        var companyID = e.shapes[0].data.properties.companyUid;
        var locationIndex = e.shapes[0].data.properties.index;
        var isPOI = e.shapes[0].data.properties.POI; // console.log(locationIndex, "index")

        props.setMapActive(locationIndex);

        if (isPOI) {
          //handle POI Click
          var POIIndex = e.shapes[0].data.properties.index;
        }
      });
    });
  };

  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    id: "myMap",
    style: {
      height: height + 'px'
    }
  }), /*#__PURE__*/React.createElement(LoadScript, {
    url: "https://atlas.microsoft.com/sdk/javascript/mapcontrol/2/atlas.min.js",
    onLoad: handleMapControlScript
  }), /*#__PURE__*/React.createElement(LoadScript, {
    url: "https://atlas.microsoft.com/sdk/javascript/service/2/atlas-service.min.js",
    onLoad: handleMapServiceScript
  }));
};

export default LocationAzureMap;